import React, {FC} from "react";
import {useIntl} from "react-intl";
import style from './style.module.css';
import { MoreVertical, Pencil, Trash2 } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../../../../../ui/dropdown-menu";

interface IIntervalPopoverMenu {
  setIntervalToDelete: () => void
  setActivityToEdit: () => void
}

const IntervalPopoverMenu: FC<IIntervalPopoverMenu> = ({ setIntervalToDelete, setActivityToEdit }) => {
  const { formatMessage } = useIntl();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className={style.MenuIcon}>
          <MoreVertical className="h-4 w-4" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={setActivityToEdit}>
          <Pencil className="h-4 w-4" />
          {formatMessage({ id: 'EDIT' })}
        </DropdownMenuItem>
        <DropdownMenuItem onClick={setIntervalToDelete} className="text-destructive focus:text-destructive">
          <Trash2 className="h-4 w-4" />
          {formatMessage({ id: 'DELETE' })}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default IntervalPopoverMenu;
